import { render, staticRenderFns } from "./newstudy.vue?vue&type=template&id=8f3e346a&lang=pug&"
import script from "./newstudy.vue?vue&type=script&lang=js&"
export * from "./newstudy.vue?vue&type=script&lang=js&"
import style0 from "./newstudy.vue?vue&type=style&index=0&id=8f3e346a&prod&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports